module.exports = __webpack_public_path__ + "static/media/factor-demo-small.c11bf8f8.mp4";